import { useCallback, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { applicationsStore } from 'pages/ApplicationsPage/model/applicationsStore'
import { getStudentGroups } from '../../../utils/studentGroups'

export const useFooterNav = currentApplication => {
	const navigate = useNavigate()
	const location = useLocation()
	const navigateToApp = useCallback(
		path => navigate(path, { state: location.state }),
		[navigate, location.state],
	)
	const studentGroups = getStudentGroups(applicationsStore.applications.slice())

	const currentStudentIndex = studentGroups.findIndex(
		group => group.studentId === currentApplication?.studentId,
	)
	const currentStudentGroup = studentGroups[currentStudentIndex] || null
	const studentApps = currentStudentGroup?.apps || []
	const currentAppIndex = studentApps.findIndex(
		item => String(item?.id) === String(currentApplication?.id),
	)

	const prevApp =
		studentApps.length > 0
			? studentApps[
					(currentAppIndex - 1 + studentApps.length) % studentApps.length
				]
			: null
	const nextApp =
		studentApps.length > 0
			? studentApps[(currentAppIndex + 1) % studentApps.length]
			: null
	const prevStudentGroup =
		currentStudentIndex > 0 ? studentGroups[currentStudentIndex - 1] : null
	const nextStudentGroup =
		currentStudentIndex >= 0 && currentStudentIndex < studentGroups.length - 1
			? studentGroups[currentStudentIndex + 1]
			: null

	useEffect(() => {
		const onKey = e => {
			const tag = String(e.target?.tagName || '').toUpperCase()
			if (tag === 'INPUT' || tag === 'TEXTAREA' || e.target?.isContentEditable)
				return
			if (e.key === 'ArrowLeft' && prevApp)
				navigateToApp(`/applications/${prevApp.id}`)
			if (e.key === 'ArrowRight' && nextApp)
				navigateToApp(`/applications/${nextApp.id}`)
		}
		window.addEventListener('keydown', onKey)
		return () => window.removeEventListener('keydown', onKey)
	}, [navigateToApp, nextApp, prevApp])

	return {
		currentApplication,
		studentApps,
		currentAppIndex,
		prevApp,
		nextApp,
		prevStudentGroup,
		nextStudentGroup,
		navigate: navigateToApp,
	}
}
